export const getPricingPageUrl = (hasTakenTrial = false, hasTakenTeamTrial = false, currentPlan = "basic") => {
    return `/pricing?trial=${hasTakenTrial}&teamTrial=${hasTakenTeamTrial}&currentPlan=${currentPlan}`;
};
